import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchErrorResults } from "../../services/errorResults";
import { STATUS } from "../../constants";

export const getErrorResults = createAsyncThunk("errorResults/fetchErrorResults", async () => {
  const response = await fetchErrorResults();
  return response.data;
});

const errorResultSlice = createSlice({
  name: "error_results",
  initialState: { data: [], status: STATUS.DEFAULT },
  reducers: {},
  extraReducers: {
    [getErrorResults.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.status = STATUS.SUCCEED;
    },
    [getErrorResults.rejected]: (state) => {
      state.status = STATUS.FAILED;
    },
    [getErrorResults.pending]: (state) => {
      state.status = STATUS.LOADING;
    },
  },
});

export default errorResultSlice;
